import React from 'react';
import { EyeIcon, GraduationCapIcon, PencilLineIcon, RotateCcwIcon } from 'lucide-react';
import { teachingFlow } from '../data/content';
const FLOW_ICONS = [GraduationCapIcon, EyeIcon, PencilLineIcon, RotateCcwIcon];
export function SystemSection() {
  return <section className="w-full bg-slate-950 px-5 py-12 text-white sm:py-16" data-id="element-171" data-mp="36jsh6l18xwpj">
      <div className="mx-auto max-w-[860px] text-center" data-id="element-172" data-mp="36lwicv7rghm4">
        <h2 className="text-balance text-[clamp(1.6rem,4.5vw,2.6rem)] font-black uppercase leading-[0.95] tracking-tight" data-id="element-173" data-mp="31lqyi17qfzel">
          Everything you need.{' '}
          <span className="text-orange-500" data-id="element-174" data-mp="2sseyf9b5x2vk">One complete teaching system.</span>
        </h2>

        <p className="mx-auto mt-4 max-w-[640px] text-balance text-[1rem] leading-relaxed text-white/85 sm:text-[1.1rem]" data-id="element-175" data-mp="2sq14j3s7xwpl">
          ANATOMY READY™ brings every body system—from cells and bones to the
          brain, heart, lungs and kidneys—into{' '}
          <strong className="font-extrabold text-white" data-id="element-176" data-mp="2dwftg7jcniun">
            6 organized volumes
          </strong>
          , so you always know what to teach and how to present it.
        </p>

        <ol className="mx-auto mt-8 grid max-w-[680px] grid-cols-2 gap-px overflow-hidden rounded-lg bg-orange-500/30 sm:grid-cols-4" aria-label="Teaching flow" data-id="element-177" data-mp="18q6kgrvyuj25">
          {teachingFlow.map((step, index) => {
          const Icon = FLOW_ICONS[index % FLOW_ICONS.length];
          return <li key={step} className="flex flex-col items-center gap-2 bg-slate-900 px-3 py-4" data-id="element-178" data-mp="1mq8uxt1y2a7d" data-mpi={index}>
                <Icon className="h-6 w-6 text-orange-500" aria-hidden="true" data-id="element-179" data-mp="1crs02kzvxbg1" />
                <span className="text-[1rem] font-black uppercase tracking-tight text-white sm:text-[1.1rem]" data-id="element-180" data-mp="1ctw1mwab9yd5">
                  {step}
                </span>
              </li>;
        })}
        </ol>

        <p className="mt-6 text-[0.95rem] font-bold text-white/90" data-id="element-181" data-mp="6bfwg4ean1d2">
          Less searching. More time teaching.
        </p>
      </div>
    </section>;
}